import api from '../api'

const state = {
  all: [],
  clientCampaigns: [],
  campaign: null
}

const actions = {
  getCampaigns: ({ state, commit }) => {
    return api.getAllCampaigns().then(campaigns => {
      return commit('setAllCampaigns', campaigns)
    })
  },
  getClientCampaigns: ({ state, commit }, id) => {
    return api.getClientCampaigns(id).then(campaigns => {
      return commit('setClientCampaigns', campaigns)
    })
  },
  addCampaign: ({ state, commit }, newCampaign) => {
    return api.addSingleCampaign(newCampaign).then(campaign => {
      return commit('setSingleCampaign', campaign)
    })
  },
  getCampaign: ({ state, commit }, id) => {
    return api.getSingleCampaign(id).then(campaign => {
      return commit('setSingleCampaign', campaign)
    })
  },
  updateCampaign: ({ state, commit }, data) => {
    return api.updateSingleCampaign(data)
  },
  deleteCampaign: ({ state, commit }, id) => {
    return api.deleteSingleCampaign(id)
  },
  cloneCampaign: ({ state, commit }, id) => {
    return api.cloneSingleCampaign(id)
  }
}

const mutations = {
  setAllCampaigns (state, campaigns) {
    state.all = campaigns
  },
  setSingleCampaign (state, campaigns) {
    state.campaign = campaigns
  },
  setClientCampaigns (state, campaign) {
    state.clientCampaigns = campaign
  }
}

const getters = {
  all: state => {
    return state.all
  },
  campaign: state => {
    return state.campaign
  },
  clientCampaigns: state => {
    return state.clientCampaigns
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/campaigns.js